import { useEffect } from "react";
import { useRouter } from "next/router";
import { withAuthUser } from "next-firebase-auth";
import { useAuth } from "@/components/auth/hooks/useAuth";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
// BOOTSTRAP
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
// COMPONENTS
import BootstrapSpinner from "@/components/elements/LoadingPlaceholders/BootstrapSpinner";
import SideLinks from "@/components/core/CustomerService/SideLinks/SideLinks";
import { NextSeo } from "next-seo";

function AboutUs() {
  const auth = useAuth();
  const router = useRouter();

  const { t } = useTranslation("about-us");

  // If the user is not allowed will be redirect to homepage.
  useEffect(() => {
    if (auth.isUserSupplier()) {
      router.push("/home-supplier");
    }
  }, [[], auth]);

  return auth.isUserSupplier() ? (
    <BootstrapSpinner />
  ) : (
    <Container fluid className="px-0">
      <NextSeo
        title={t("about-us")}
        description={""}
        openGraph={{
          type: "website",
          title: t("about-us"),
          description: "",
          url: `${process.env.NEXT_PUBLIC_BASE_URL}/about-us`,
        }}
      />
      <Row key="catalogPage" className="mx-0 px-3">
        <SideLinks />
        <Col className="px-0 px-lg-5" style={{ maxWidth: "80rem" }}>
          <h1 className="fs-1 fw-semibold text-center text-md-start text-uppercase pb-5">{t("about-us")}</h1>
          <div>
            <p>{t("subtitle1")}</p>
            <p>{t("subtitle2")}</p>
            <p>{t("subtitle3")}</p>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common", "header", "footer", "about-us", "services-side-links", "db-translations"])),
    },
  };
}

export default withAuthUser({})(AboutUs);
